import { render, staticRenderFns } from "./PriceSuggestionConfigurationSidebar.vue?vue&type=template&id=4fbfbde0&scoped=true&"
import script from "./PriceSuggestionConfigurationSidebar.vue?vue&type=script&lang=js&"
export * from "./PriceSuggestionConfigurationSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fbfbde0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fbfbde0')) {
      api.createRecord('4fbfbde0', component.options)
    } else {
      api.reload('4fbfbde0', component.options)
    }
    module.hot.accept("./PriceSuggestionConfigurationSidebar.vue?vue&type=template&id=4fbfbde0&scoped=true&", function () {
      api.rerender('4fbfbde0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/catalog/price-suggestion-configuration/PriceSuggestionConfigurationSidebar.vue"
export default component.exports